import { render, staticRenderFns } from "./NgControlToggle.vue?vue&type=template&id=44ac306c"
import script from "./NgControlToggle.vue?vue&type=script&lang=js"
export * from "./NgControlToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports